<template>
    <el-table
            :data="tableData"
            border
            stripe
            style="width: 90%">
        <el-table-column
                fixed
                type="index"
                label="序号"
                :index="indexMethod"
                width="100">
        </el-table-column>
        <el-table-column
                fixed
                prop="userName"
                label="申请人"
                width="150">
        </el-table-column>
        <el-table-column
                prop="amount"
                label="提现申请金额"
                width="110">
        </el-table-column>
        <el-table-column
                prop="realityAmount"
                label="实际到账金额"
                width="110">
        </el-table-column>
        <el-table-column
                prop="proceduresAmount"
                label="提现手续费"
                width="100">
        </el-table-column>
<!--        <el-table-column-->
<!--                prop="proceduresAmount"-->
<!--                label="提现账户信息"-->
<!--                width="120">-->
<!--        </el-table-column>-->
        <el-table-column
                prop="createTime"
                label="申请时间"
                width="200">
        </el-table-column>
        <el-table-column
                prop="statusText"
                label="审核状态"
                width="120">
        </el-table-column>
        <el-table-column
                prop="auditTime"
                label="审核时间"
                width="120">
        </el-table-column>
        <el-table-column
                prop="remark"
                label="备注"
                width="300">
        </el-table-column>
        <el-table-column
                fixed="right"
                label="操作"
                width="100">
            <template slot-scope="scope">
                <el-button type="text" size="small" @click="audit(scope.row)">审核</el-button>
            </template>
        </el-table-column>
    </el-table>

</template>

<script>
    import {audit} from "../../network/reflectRecord";

    export default {
        name: "ReflectRecordTable",
        props: {
            tableData: Array
        },
        data() {
            return {}
        },
        methods: {
            indexMethod(index) {
                return index + 1;
            },
            audit(record) {
                this.$emit("audit",record)
            },
            changeStatus() {

            },
        },
    }
</script>

<style scoped></style>
